import LegalNotices from "../../components/footer/LegalNotices";


const LegalNoticesView = () => {

    return (
        <div className="legal-notices">
            <LegalNotices/>
        </div>
    );
};

export default LegalNoticesView;